import React from "react";
import { Input, Button, Icon, Tooltip, Dropdown, Menu } from "antd";
import { useTranslation } from "react-i18next";

const CampaignsToolbar = ({
  search,
  onSearchChange,
  sortValue,
  onSortChange,
  viewMode,
  onViewModeChange,
  onToggleFilters,
}) => {
  const { t } = useTranslation();

  const sortMenu = (
    <Menu
      selectedKeys={[sortValue]}
      onClick={({ key }) => onSortChange(key)}
    >
      <Menu.Item key="recent">{t("Most recent")}</Menu.Item>
      <Menu.Item key="name">{t("Name")}</Menu.Item>
      <Menu.Item key="budget">{t("Budget")}</Menu.Item>
    </Menu>
  );

  return (
    <div className="campaignsManager__toolbar">
      <Button
        className="campaignsManager__filters-btn"
        onClick={onToggleFilters}
      >
        {t("Filters")} <Icon type="filter" />
      </Button>

      <Input
        className="campaignsManager__toolbar-search"
        prefix={<Icon type="search" />}
        placeholder={t("Search")}
        value={search}
        onChange={(e) => onSearchChange(e.target.value)}
        allowClear
      />

      <div className="campaignsManager__toolbar-right">
        <Button.Group>
          <Tooltip title={t("Grid view")}>
            <Button
              type={viewMode === "grid" ? "primary" : "default"}
              icon="appstore"
              onClick={() => onViewModeChange("grid")}
            />
          </Tooltip>
          <Tooltip title={t("List view")}>
            <Button
              type={viewMode === "list" ? "primary" : "default"}
              icon="bars"
              onClick={() => onViewModeChange("list")}
            />
          </Tooltip>
        </Button.Group>

        <Dropdown overlay={sortMenu} trigger={["click"]}>
          <Button className="campaignsManager__sort-btn">
            {t("Sort")}
            <Icon type="swap" style={{ transform: "rotate(90deg)" }} />
          </Button>
        </Dropdown>
      </div>
    </div>
  );
};

export default CampaignsToolbar;
